module.exports = __webpack_public_path__ + "img/Image - Header 5@2x(3).a91049d1.png";